import React from 'react';
import { LagoonContext } from '@src/AppContext/LagoonContext';
import { useHeaderMenu } from '@src/state/headerMenu';
import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { V2DropdownMenu } from '@uhg-abyss/web/ui/DropdownMenu';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';

export const MyAccount = () => {
  const lagoonContext = React.useContext(LagoonContext);
  const featureToggles = lagoonContext.getTable('feature-toggles');
  const { toggleMyAccount } = useHeaderMenu.actions();

  const useUpdatedAuth = featureToggles.getRow(
    'US10732847_UPDATED_CORE_V2_ENDPOINTS'
  )?.active;

  const logoutUrl = useUpdatedAuth
    ? `${config('IDENTITY_API_URL')}/logout/v2`
    : `${config('IDENTITY_API_URL')}/logout`;

  const handleOpenChange = (isOpen) => {
    if (!isOpen) {
      toggleMyAccount(false);
    }
  };

  const openNewTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleAccountInfoClick = () => {
    event('ACCOUNT_INFORMATION_CLICK');
    openNewTab(config('ACCOUNT_INFO_URL'));
  };

  const handleCommPrefClick = () => {
    event('COMMUNICATION_PREFERENCES_CLICK');
    openNewTab(config('COMMUNICATION_PREF_URL'));
  };

  const handleSignOutClick = () => {
    event('SIGN_OUT_CLICK');
    window.location.assign(logoutUrl);
  };

  const menuItems = [
    {
      title: 'Account Information',
      onClick: handleAccountInfoClick,
      'data-testid': 'top-bar-account-info-link',
    },
    {
      title: 'Communication Preferences',
      onClick: handleCommPrefClick,
      'data-testid': 'top-bar-comm-pref-link',
    },
    {
      title: 'Sign Out',
      onClick: handleSignOutClick,
      'data-testid': 'top-bar-sign-out-link',
    },
  ];

  return (
    <V2DropdownMenu
      data-testid="top-bar-my-account-link"
      ariaLabel="click to open my account dropdown"
      label="My Account"
      before={<IconSymbol size={18} icon="account_circle" />}
      outline={false}
      menuItems={menuItems}
      onOpenChange={handleOpenChange}
      css={{
        'dropdown-menu-root': {
          textAlign: 'left',
        },
      }}
    />
  );
};
